import { Typography } from '../../../atoms/typography/typography';
import { ReactNode } from 'react';
import { FeaturedIcon } from '../../../ui';
import { IconStar } from '@maia/icons';

type ProductProps = {
  icon: ReactNode;
  title: string;
  characteristic?: string;
  isSpecialLimit: boolean;
};

export function Product(props: ProductProps) {
  const { icon, title, characteristic, isSpecialLimit } = props;

  return (
    <div className="flex items-center gap-x-12 w-full">
      <div className="flex justify-center items-center size-32 bg-primary50 rounded-6">
        {icon}
      </div>
      <div className="flex flex-col">
        <Typography
          variant="body-xs"
          weight="medium"
          className="text-grayscale600"
        >
          {title}
        </Typography>
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale300"
        >
          {characteristic}
        </Typography>
      </div>
      {isSpecialLimit && (
        <FeaturedIcon
          icon={<IconStar />}
          variant="light-circle"
          color="warning"
          size="xs"
          className="ml-auto"
        />
      )}
    </div>
  );
}
